import React from "react";
import { Link } from "react-router-dom";

function logout() {
  localStorage.clear();
  window.location.href = "/";
}

const Support = () => {
  return (
    <div className="support">
      <nav className="navbar navbar-expand navbar-light fixed-top">
        <div className="container">
          <Link className="navbar-brand" to={"/"} onClick={logout()}></Link>
        </div>
      </nav>
    </div>
  );
};

export default Support;
